import HeaderContact from "../../components/HeaderContact";
import Mail from "../../components/Mail";
import Adress from "../../components/Adress";

import pens from "../../images/pens.png";
import bgMobileBlue from "../../images/bgMobileBlue.png";
import bgDeskOcker from "../../images/bgDeskOcker.svg";
import mailIcon from "../../images/mail.svg";

const Contact = () => {
  return (
    <div className="">
      <HeaderContact
        heading="Kontaktieren Sie uns"
        desktopBgImgSrc={bgDeskOcker}
        mobileBgImgSrc={bgMobileBlue}
        imgSrc={mailIcon}
        imgAlt="Mail"
      >
        Senden Sie uns gerne Ihre Anfrage per E-Mail oder rufen Sie uns unter an.
      </HeaderContact>

      <div className="relative z-20 pt-24">
        <div className="grid place-items-center">
          <div className="mt-20 lg:mt-0">
            <img className="px-4 mb-7 mx-auto" src={pens} alt="Stifte" />
            <Adress />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
